export const apiBaseUrl =
  import.meta.env.VITE_API_BASE_URL || (window.location.hostname === "localhost" ? "http://localhost:4001/api" : "/api");

export async function apiPost<TResponse>(path: string, payload: unknown) {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const body = (await response.json().catch(() => null)) as { error?: string } | TResponse | null;

  if (!response.ok) {
    throw new Error((body as { error?: string } | null)?.error || "iBox could not complete that request.");
  }

  return body as TResponse;
}

export async function apiGetAuthed<TResponse>(path: string, accessToken: string) {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const body = (await response.json().catch(() => null)) as { error?: string } | TResponse | null;

  if (!response.ok) {
    throw new Error((body as { error?: string } | null)?.error || "iBox could not load that request.");
  }

  return body as TResponse;
}

export async function apiPostAuthed<TResponse>(path: string, payload: unknown, accessToken: string) {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  const body = (await response.json().catch(() => null)) as { error?: string } | TResponse | null;

  if (!response.ok) {
    throw new Error((body as { error?: string } | null)?.error || "iBox could not complete that request.");
  }

  return body as TResponse;
}
